import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type PropsWithChildren } from 'react';

import { GuidedModeProvider } from '../guidance/GuidedModeContext';
import { GuidedField } from '../guidance/FieldHelp';
import { productFieldHelpRegistry } from '../guidance/fieldHelpRegistry';
import { createAppQueryClient } from '../query/queryClient';
import { ThemeProvider } from '../theme/ThemeContext';
import { UnitDisplayProvider } from '../units/UnitDisplayContext';

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(() => createAppQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <GuidedModeProvider>
          <UnitDisplayProvider>
            <GuidedField registry={productFieldHelpRegistry}>
              {children}
            </GuidedField>
          </UnitDisplayProvider>
        </GuidedModeProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
